export default __webpack_public_path__ + "static/media/wasd.3069b7fe.png";